(function () {
  var COLOR_MAP = {
    onyx: '#181818',
    quartz: '#f9b5b1',
    iris: '#68d8fc',
    sage: '#7cf4a2'
  };

  function labelText(label) {
    var clone = label.cloneNode(true);
    clone.querySelectorAll('.visually-hidden, .label-unavailable').forEach(function (el) {
      el.remove();
    });
    return clone.textContent.trim().toLowerCase();
  }

  function enhance(fieldset) {
    if (fieldset.dataset.wmSwatchesInit) return;
    var legend = fieldset.querySelector('legend');
    if (!legend || legend.textContent.trim().toLowerCase() !== 'color') return;

    var labels = fieldset.querySelectorAll('label');
    var matched = 0;
    labels.forEach(function (label) {
      var hex = COLOR_MAP[labelText(label)];
      if (!hex) return;
      matched++;
      label.classList.add('wm-color-circle');
      label.style.setProperty('--wm-swatch-color', hex);
    });

    if (matched > 0) {
      fieldset.classList.add('wm-color-circle-group');
      fieldset.dataset.wmSwatchesInit = 'true';
    }
  }

  function init(root) {
    (root || document).querySelectorAll('fieldset.product-form__input--pill').forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });

  // Dawn/Rise re-fetches server HTML for the variant fieldset on every
  // option click (product-info.js updateOptionValues), replacing our
  // enhanced markup with raw markup. Re-enhance once that swap settles.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function () {
      init();
    });
  }
})();
